import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

import NotFound from '../../app/layout/NotFound';
import { RootStoreContext } from '../../app/stores/rootStore';

interface IProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps<any>>;
}

const RFCAuthCompleteRoute: React.FC<IProps> = ({ component: Component, ...rest }) => {
  const rootStore = useContext(RootStoreContext);
  const { isLogInRfcAuth } = rootStore.memberStore;
  return <Route {...rest} render={(props) => (isLogInRfcAuth ? <Component {...props} /> : <NotFound />)} />;
};

export default observer(RFCAuthCompleteRoute);
